import { Route, Routes } from 'react-router-dom';

import { Layout } from './components/Layout';
import { CredentialsPage } from './pages/account/CredentialsPage';
import { DashboardPage } from './pages/account/DashboardPage';
import { DeleteAccountPage } from './pages/account/DeleteAccountPage';
import { SessionsPage } from './pages/account/SessionsPage';
import { GroupDetailPage } from './pages/admin/GroupDetailPage';
import { GroupsPage } from './pages/admin/GroupsPage';
import { UsersPage } from './pages/admin/UsersPage';
import { EmailVerifiedPage } from './pages/auth/EmailVerifiedPage';
import { ErrorPage } from './pages/auth/ErrorPage';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage';
import { OauthAuthorizePage } from './pages/auth/OauthAuthorizePage';
import { OauthFinalizePage } from './pages/auth/OauthFinalizePage';
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage';
import { SessionEndPage } from './pages/auth/SessionEndPage';
import { SignInPage } from './pages/auth/SignInPage';
import { SignUpPage } from './pages/auth/SignUpPage';
import { VerifyEmailPage } from './pages/auth/VerifyEmailPage';
import { NotFoundPage } from './pages/NotFoundPage';

export function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/oauth/authorize" element={<OauthAuthorizePage />} />
        <Route path="/oauth/finalize" element={<OauthFinalizePage />} />
        <Route path="/session/end" element={<SessionEndPage />} />
        <Route path="/auth/signin" element={<SignInPage />} />
        <Route path="/auth/signup" element={<SignUpPage />} />
        <Route path="/auth/email-verified" element={<EmailVerifiedPage />} />
        <Route path="/auth/verify-email" element={<VerifyEmailPage />} />
        <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
        <Route path="/auth/error" element={<ErrorPage />} />
        <Route path="/account" element={<DashboardPage />} />
        <Route path="/account/credentials" element={<CredentialsPage />} />
        <Route path="/account/sessions" element={<SessionsPage />} />
        <Route path="/account/delete" element={<DeleteAccountPage />} />
        <Route path="/admin/users" element={<UsersPage />} />
        <Route path="/admin/groups" element={<GroupsPage />} />
        <Route path="/admin/groups/:groupId" element={<GroupDetailPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
}
